import { OPTIONAL_STRING, OPTIONAL_TEXT_3000, REQUIRED_STRING } from '@/components/Form/schema';
import { uniqueEmailField } from '@/forms/forms';
import { GetUserPasswordLoginByEmailDocument } from '@/generated/graphql';
import { z } from 'zod';
import { $t } from '../../plugins/fluent';

export const PASSWORD_MIN_LENGTH = 12;

export function getUserUpdateSchema(email: string) {
    return z.object({
        firstName: REQUIRED_STRING,
        lastName: REQUIRED_STRING,
        email: uniqueEmailField(GetUserPasswordLoginByEmailDocument, email),
        isAdmin: z.boolean(),
    });
}

const USER_CREATE_EMAIL_FIELD = uniqueEmailField(GetUserPasswordLoginByEmailDocument);

export const userCreateSchema = z.object({
    firstName: REQUIRED_STRING,
    lastName: REQUIRED_STRING,
    email: USER_CREATE_EMAIL_FIELD,
    password: z
        .string({ required_error: $t('input-required') })
        .min(PASSWORD_MIN_LENGTH, $t('min-characters', { count: PASSWORD_MIN_LENGTH })),
    isAdmin: z.boolean(),
});

export const userActivateSchema = z.object({
    firstName: REQUIRED_STRING,
    lastName: REQUIRED_STRING,
    position: OPTIONAL_STRING,
    company: OPTIONAL_STRING,
    notes: OPTIONAL_TEXT_3000,
});
